$( document ).ready(function() {
    $(document).on("click","#subscribeButton", function(e) {

		e.preventDefault();

        const submitButton = $(this);

        if($("#newsletter-form")[0].reportValidity()) {

        // grecaptcha.enterprise.ready(async () => {
        //     const token = await grecaptcha.enterprise.execute('6LcVqwIqAAAAAP-ei9UPfbRNytEWXJAFyswD8vMl', {action: 'LOGIN'}).then(function(token) {

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });

            const form = $("#newsletter-form");
            const url  = form.attr("action");
            const data = form.serialize();

            $('#subscriptionMessage').remove();

            $.ajax({
                type 		: "POST",
                url 		: url,
                data 		: data,
                dataType 	: 'json',
                beforeSend: function(xhr) {
                    submitButton.prop('disabled', true);
                    $('.responseMessage').html('');
                },
                success: function(data) {
                    form.html(data.message)
                },
                error: function(response) {
                    let data = jQuery.parseJSON(response.responseText);
                    $('#responseMessageBox').append('<span id="subscriptionMessage" class="text-danger"><strong>' + data.message +'</strong></span>')
                },
                complete: function() {
                    submitButton.prop('disabled', false);
                }
            });
        }
    });
});
    // });
// });
